// extracted by mini-css-extract-plugin
module.exports = {"container":"Pn-z","copyContainer":"Qn-z"};